import {
  ROUTE_DESTINATIONS,
  ROUTE_HOME,
  ROUTE_LOGIN,
  ROUTE_REGISTER,
} from 'src/lib'
import { Navbar, UnprotectedRoutes } from 'src/layouts'
import { createBrowserRouter } from 'react-router-dom'
import {
  DestinationsPage,
  HomePage,
  LoginPage,
  NotFoundPage,
  RegisterPage,
} from 'src/pages'

export const createRouter = () =>
  createBrowserRouter([
    {
      lazy: async () => ({ Component: Navbar }),
      children: [
        {
          path: ROUTE_HOME,
          lazy: async () => ({
            Component: HomePage,
          }),
        },
        {
          path: ROUTE_DESTINATIONS,
          lazy: async () => ({
            Component: DestinationsPage,
          }),
        },
      ],
    },
    {
      lazy: async () => ({ Component: UnprotectedRoutes }),
      children: [
        {
          path: ROUTE_REGISTER,
          lazy: async () => ({
            Component: RegisterPage,
          }),
        },
        {
          path: ROUTE_LOGIN,
          lazy: async () => ({
            Component: LoginPage,
          }),
        },
      ],
    },
    // {
    //   lazy: async () => ({ Component: ProtectedRoutes }),
    //   children: [
    //     {
    //       path: ROUTE_MY_BETS,
    //       lazy: async () => ({
    //         Component: MyBetsPage,
    //       }),
    //     },
    //   ],
    // },
    {
      path: '*',
      lazy: async () => ({
        Component: NotFoundPage,
      }),
    },
  ])
